(() => {
  const config = document.getElementById('ccr-a11y-labels');
  if (!config) return;
  let text;
  try { text = JSON.parse(config.textContent); } catch { return; }
  const set = (node, name, value) => {
    if (node && value && node.getAttribute(name) !== value) node.setAttribute(name, value);
  };
  const each = (scope, selector, callback) => {
    if (scope.nodeType === 1 && scope.matches(selector)) callback(scope);
    scope.querySelectorAll?.(selector).forEach(callback);
  };
  const patch = (scope) => {
    each(scope, 'iframe[src*="guaranteed-reviews.com"]', (frame) => {
      if (!frame.title) set(frame, 'title', text.reviews);
    });
    each(scope, 'input[x-grc-model="search"]', (input) => {
      if (!input.getAttribute('aria-label')) set(input, 'aria-label', text.review_search);
    });
    each(scope, 'slideshow-carousel', (carousel) => set(carousel, 'aria-label', text.slideshow));
    each(scope, 'product-gallery scroll-carousel', (carousel) => set(carousel, 'aria-label', text.photos));
    each(scope, 'input[name^="globe-delivery-method"]', (radio) => {
      set(radio, 'aria-label', radio.value === 'pickup' ? text.pickup : text.home);
    });
    each(scope, 'img[alt*="#"]', (image) => {
      const match = image.alt.match(/\s*#(?:couleurs?|colors?|colours?|colores)_([^#]+)$/i);
      if (!match) return;
      set(image, 'data-ccr-media-group', match[0].trim().slice(1));
      set(image, 'alt', image.alt.slice(0, match.index).trim());
    });
  };
  let host;
  let root;
  let rootObserver;
  let opened = false;
  let opener;
  let radioFocus;
  let pendingConfirm = false;
  let scheduled = false;
  const pausedDrawers = new Map();
  const pauseDrawer = () => {
    if (!opener?.drawer) return;
    const drawer = document.getElementById('cart-drawer');
    const trap = drawer?.open ? drawer.focusTrap : null;
    if (trap?.active && !trap.paused && typeof trap.pause === 'function') {
      trap.pause();
      pausedDrawers.set(drawer, trap);
    }
  };
  const resumeDrawer = () => {
    for (const [drawer, trap] of pausedDrawers) {
      if (drawer.isConnected && drawer.open && trap.active && trap.paused) trap.unpause();
    }
    pausedDrawers.clear();
  };
  const visible = (element) => element?.getClientRects().length && getComputedStyle(element).visibility !== 'hidden';
  const pickupRadio = () => {
    const scope = opener?.drawer ? document.getElementById('cart-drawer') : document.querySelector('main');
    return scope?.querySelector('input[name^="globe-delivery-method"][value="pickup"]');
  };
  const restore = () => {
    const radio = pickupRadio();
    if (radio) radio.focus({ preventScroll: true });
  };
  const confirmButton = () => Array.from(root?.querySelectorAll('button.globe-cart-select-btn') || []).reverse().find(visible);
  const refreshGlobe = () => {
    if (!root || !host?.isConnected) return;
    const dialog = root.querySelector('#globe-cart-container');
    set(dialog, 'aria-modal', 'true');
    set(dialog, 'aria-label', text.choose);
    for (const [id, label] of Object.entries({
      'globe-cart-close': 'close', 'globe-cart-filter-btn': 'filter',
      'globe-cart-search-clear': 'clear', 'globe-cart-search-input': 'search',
      'globe-cart-country-selector': 'country', 'globe-cart-mobile-search-btn': 'search',
      'globe-cart-mobile-popup-close': 'close'
    })) set(root.getElementById(id), 'aria-label', text[label]);
    root.querySelectorAll('.globe-cart-row').forEach((row) => {
      const name = row.querySelector('.globe-cart-row-name')?.textContent.trim();
      if (!name) return;
      const address = row.querySelector('.globe-cart-row-address')?.textContent.trim();
      const distance = row.querySelector('.globe-cart-row-distance')?.textContent.trim();
      set(row, 'tabindex', '0');
      set(row, 'role', 'button');
      set(row, 'aria-label', [name, address, distance].filter(Boolean).join(', '));
    });
    const isOpen = Boolean(dialog?.open);
    if (isOpen) pauseDrawer();
    if (isOpen && !opened) {
      opened = true;
      const search = root.getElementById('globe-cart-search-input');
      const target = visible(search) ? search : root.getElementById('globe-cart-mobile-search-btn');
      target?.focus({ preventScroll: true });
    } else if (!isOpen && opened) {
      opened = false;
      pendingConfirm = false;
      resumeDrawer();
      requestAnimationFrame(restore);
    }
    if (pendingConfirm && isOpen) {
      const button = confirmButton();
      if (button) {
        pendingConfirm = false;
        button.focus({ preventScroll: true });
      }
    }
    if (isOpen && !root.activeElement && document.activeElement === document.body) {
      const search = root.getElementById('globe-cart-search-input');
      const target = visible(search) ? search : root.getElementById('globe-cart-mobile-search-btn');
      target?.focus({ preventScroll: true });
    }
  };
  const scheduleGlobe = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; refreshGlobe(); });
  };
  const connectGlobe = () => {
    const next = document.getElementById('globe-cart-shadow-host');
    if (!next?.shadowRoot || next.shadowRoot === root) return;
    rootObserver?.disconnect();
    host = next;
    root = next.shadowRoot;
    opened = false;
    const style = document.createElement('style');
    style.textContent = ':is(button,input,select,[tabindex]):focus-visible{outline:2px solid #5e2733!important;outline-offset:2px;box-shadow:0 0 0 2px #fff}.globe-cart-row:focus-visible{outline-offset:-3px}';
    root.append(style);
    root.addEventListener('keydown', (event) => {
      const row = event.target.closest?.('.globe-cart-row');
      if (!row || event.target !== row || !['Enter', ' '].includes(event.key)) return;
      event.preventDefault();
      event.stopPropagation();
      pendingConfirm = true;
      row.click();
      scheduleGlobe();
    });
    rootObserver = new MutationObserver(scheduleGlobe);
    rootObserver.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'hidden', 'style'] });
    refreshGlobe();
  };
  document.addEventListener('change', (event) => {
    if (!event.target.matches?.('input[name^="globe-delivery-method"]')) return;
    opener = { drawer: Boolean(event.target.closest('cart-drawer, #cart-drawer')) };
    radioFocus = { value: event.target.value, until: performance.now() + 1500 };
    connectGlobe();
    scheduleGlobe();
  }, true);
  document.addEventListener('click', (event) => {
    if (event.target.closest?.('.globe-delivery-option, [class*="globe-delivery"]')) {
      opener = { drawer: Boolean(event.target.closest('cart-drawer, #cart-drawer')) };
      connectGlobe();
      scheduleGlobe();
    }
  }, true);
  const bodyObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes') patch(mutation.target);
      else for (const node of mutation.addedNodes) if (node.nodeType === 1) patch(node);
    }
    if (host && !host.isConnected) {
      rootObserver?.disconnect();
      root = null;
      host = null;
      if (opened) { opened = false; resumeDrawer(); requestAnimationFrame(restore); }
    }
    connectGlobe();
    if (radioFocus && performance.now() < radioFocus.until && !opened && document.activeElement === document.body) {
      const scope = opener?.drawer ? document.getElementById('cart-drawer') : document.querySelector('main');
      scope?.querySelector(`input[name^="globe-delivery-method"][value="${radioFocus.value}"]`)?.focus({ preventScroll: true });
      radioFocus = null;
    }
  });
  patch(document);
  connectGlobe();
  bodyObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['alt', 'aria-label', 'src'] });
})();
